/**
 * internal name -> external (e.g., query param) name
 * @enum {string}
 */
export const ONBOARDING_QUERY_PARAMS = {
  country: 'country',
  email: 'email',
  website: 'website',
  platform: 'platform',
  platformVersion: 'platformVersion',
  plugin: 'plugin',
  pluginVersion: 'pluginVersion',
  salesRepId: 'sales_rep_id',
  products: 'products',
  referral: 'referral',
  utmContent: 'utm_content',
  utmCampaign: 'utm_campaign',
  utmFriendbuy: 'referralCode',
  utmMedium: 'utm_medium',
  utmSource: 'utm_source',
  region: 'region',
};
